module.exports = __webpack_public_path__ + "img/21280493000130.2e6a37db.png";